import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await register(email, password, name);
    setBusy(false);
    if (res.ok) {
      if (res.user?.email_verified === false) {
        navigate("/verify-email");
        return;
      }
      const hasPending = !!sessionStorage.getItem("inlight_current_prayer");
      navigate(hasPending ? "/prayer" : "/builder");
    } else setError(res.error);
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--sanctuary-bg)" }}>
      <Header />
      <div className="sanctuary-glow absolute inset-x-0 top-16 h-[420px] -z-0 pointer-events-none" />
      <div className="relative max-w-md mx-auto px-6 pt-20 md:pt-28">
        <h1
          className="font-serif-display text-4xl md:text-5xl mb-3 tracking-tight"
          style={{ color: "var(--sanctuary-ink)" }}
          data-testid="register-title"
        >
          Begin your sanctuary
        </h1>
        <p className="mb-12 text-base" style={{ color: "var(--sanctuary-ink-soft)" }}>
          A few quiet details. Your prayers, kept softly.
        </p>

        <form onSubmit={submit} className="space-y-10">
          <div>
            <label className="block text-xs tracking-widest uppercase mb-3" style={{ color: "var(--sanctuary-ink-muted)" }}>
              Name
            </label>
            <input
              data-testid="register-name-input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-line"
              placeholder="What may we call you?"
            />
          </div>
          <div>
            <label className="block text-xs tracking-widest uppercase mb-3" style={{ color: "var(--sanctuary-ink-muted)" }}>
              Email
            </label>
            <input
              data-testid="register-email-input"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-line"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-xs tracking-widest uppercase mb-3" style={{ color: "var(--sanctuary-ink-muted)" }}>
              Password
            </label>
            <input
              data-testid="register-password-input"
              type="password"
              autoComplete="new-password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-line"
              placeholder="At least 6 characters"
            />
          </div>

          {error && (
            <p data-testid="register-error" className="text-sm" style={{ color: "var(--sanctuary-alert)" }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit-button"
            className="w-full px-8 py-4 rounded-full btn-primary text-base disabled:opacity-60"
          >
            {busy ? "Lighting the candle…" : "Create my sanctuary"}
          </button>
        </form>

        <p className="mt-10 text-sm" style={{ color: "var(--sanctuary-ink-soft)" }}>
          Already with us?{" "}
          <Link to="/login" data-testid="register-to-login-link" className="underline" style={{ color: "var(--sanctuary-accent)" }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
